module.exports = __webpack_public_path__ + "static/media/i_item_like_on.cc671a89.png";